import { useEffect } from "react";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { tokenCheckMs } from "../constants";

const cookies = new Cookies();

// Event dat de API afvuurt als de server het token afwijst.
export const sessionExpired = "dashboard:sessionExpired";

// Stuurt terug naar het inlogscherm zodra het token weg of ongeldig is.
export function useSessionGuard() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!cookies.get("token")) {
      navigate("/");
      return undefined;
    }
    const toLogin = () => navigate("/");
    const timer = setInterval(() => {
      if (!cookies.get("token")) toLogin();
    }, tokenCheckMs);
    window.addEventListener(sessionExpired, toLogin);
    return () => {
      clearInterval(timer);
      window.removeEventListener(sessionExpired, toLogin);
    };
  }, [navigate]);
}
